import React, { useContext, useState } from "react";
import { Tag } from "antd";
import Modal from "../../../../../components/modalComponent/ModalComponent";
import { expenseColors, summaryApprovalItems, totalDetailsItems } from "./WeeklyDetails.utils";
import ExpenseReportModal from "../../../components/ExpenseReportModal";
import moment from "moment";
import { ExpenseReportsContext } from "../../ExpenseReportsContext";
import { isEmpty } from "lodash";

const SummaryApproval = ({
  setSummaryIdModalSelected,
  setExpenseTab,
  getModalTitle,
  weeklyList,
  setIsModalVisible
}) => {
  return (
    <div className="flex pb-16">
      <div className="flex justify-end w-1/3 mr-6">
        <div className="text-3xl font-bold text-gray-900">Résumé :</div>
      </div>
      <div className="w-2/3">
        {summaryApprovalItems(weeklyList).map((item, index) => {
          return (
            <div
              onClick={() => {
                getModalTitle(item.label);
                setSummaryIdModalSelected(item.approvalStatusId);
                setExpenseTab(
                  weeklyList &&
                    weeklyList.filter(
                      weeklyListItem => weeklyListItem.status && weeklyListItem.status.id === item.approvalStatusId
                    )
                );
                setIsModalVisible(true);
              }}
              className={`${item.style} rounded-full text-white p-2 w-full h-8 my-1 text-center cursor-pointer`}
            >
              {item.label}: {item.totalCost} €
            </div>
          );
        })}
      </div>
    </div>
  );
};

const TotalDetails = ({ weeklyList }) => {
  return (
    <div className="flex">
      <div className="flex justify-end w-1/3 mr-6 text-3xl">
        <div className="text-3xl font-bold text-gray-900">Total :</div>
      </div>
      <div className="w-2/3">
        {totalDetailsItems.map((item, index) => (
          <div className={`${item.style} rounded-full text-white p-2 w-full h-8 my-1 text-center cursor-pointer`}>
            {item.label}: {item.totalCost} €
          </div>
        ))}
      </div>
    </div>
  );
};

const WeeklyDetailsTotal = ({ weeklyList }) => {
  const { weekDate, userRoleId, selectedUserEmail, handleOnClickDetailsView, userId } = useContext(
    ExpenseReportsContext
  );
  const [isModalVisible, setIsModalVisible] = useState(null);
  const [expenseTab, setExpenseTab] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [summaryIdModalSelected, setSummaryIdModalSelected] = useState(null);

  const getModalTitle = typeName => {
    setModalTitle(`Notes de frais : ${typeName}`);
  };

  const checkSummaryId = () => {
    if (userRoleId === 1 && (summaryIdModalSelected === 1 || summaryIdModalSelected === 2)) return true;
    if (summaryIdModalSelected === 1 && userRoleId === 3) return true;
    else if (summaryIdModalSelected === 2 && userRoleId === 2) return true;
    return false;
  };

  const isButtonAllValidateDisplayed = () => {
    if (!isEmpty(expenseTab) && expenseTab.length > 1 && checkSummaryId()) return true;
    return false;
  };

  return (
    <div className="flex flex-col mb-12 mr-10">
      <SummaryApproval
        setSummaryIdModalSelected={setSummaryIdModalSelected}
        setExpenseTab={setExpenseTab}
        weeklyList={weeklyList}
        setIsModalVisible={setIsModalVisible}
        getModalTitle={getModalTitle}
      />
      {/*<TotalDetails weeklyList={weeklyList} />*/}
      <Modal width="651px" title={modalTitle} showModal={isModalVisible} closeModal={() => setIsModalVisible(false)}>
        <ExpenseReportModal
          userId={userId}
          isButtonAllValidateDisplayed={isButtonAllValidateDisplayed()}
          userRoleId={userRoleId}
          expensesTab={expenseTab}
          closeModal={() => setIsModalVisible(false)}
          isModalVisible={isModalVisible}
          requestToTriggered={() => {
            handleOnClickDetailsView({
              match: {
                email: selectedUserEmail
              },
              start_date: moment(weekDate).format("YYYY-MM-DD")
            });
          }}
        />
      </Modal>
    </div>
  );
};

export default WeeklyDetailsTotal;



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/expenseReportsWeekly/weeklyDetails/WeeklyDetailsTotal.js